import { FC } from 'react';
import styles from './DocumentRecordCard.module.scss';

export interface DocumentRecordCardProps {
  badge?: string;
  title: string;
  subtitle: string;
  actionText?: string;
  href?: string;
}

export const DocumentRecordCard: FC<DocumentRecordCardProps> = ({
  badge = 'PDF',
  title,
  subtitle,
  actionText = 'Open in Pulse →',
  href = '#open-document',
}) => {
  return (
    <a href={href} className={styles.card}>
      <div className={styles.leftContent}>
        <div className={styles.badge} aria-label={`Format: ${badge}`}>
          {badge}
        </div>
        <div className={styles.textGroup}>
          <span className={styles.title}>{title}</span>
          <span className={styles.subtitle}>{subtitle}</span>
        </div>
      </div>
      <span className={styles.actionLink} aria-hidden="true">
        {actionText}
      </span>
    </a>
  );
};
